import React from 'react'

const TrendPage = () => {
  return (
    <div>TrendPage</div>
  )
}

export default TrendPage